import * as React from 'react';
import * as axios from 'axios';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  bookingSetFilter,
  bookingResetFilter,
  bookingSetPagination,
  fetchAllBookings,
  bookingApplyFilter,
  cancelFilter,
  setPrevPagination,
} from 'src/actions/bookingInquiryActions';
import {
  Button,
  Checkbox,
  Icon,
  Select,
  Spin,
  Tag,
  Tooltip,
  Tabs,
  Badge,
  message,
} from 'src/Library/AntdLibComponents';
import Loader from 'src/components/common/Loader';
import { searchTypeMap } from '../constants';
import { searchInquiryForShipperApi } from 'src/api/inquiry';
import SimplePaginator from 'src/components/common/SimplePaginator';
import SortIcon from 'src/components/common/icons/SortIcon';
import BookingFilterPopup from './BookingFilterPopup';
import InquiryBookingShipperCard from '../Cards/InquiryBookingShipperCard';
import InquiryBookingFFCard from '../Cards/InquiryBookingFFCard';
import BookingSideDrawer from './BookingSideDrawer';
import BookingSortPopup from './BookingSortPopup';
import { searchBookingApi, getBookingMISReport } from 'src/api/booking';
import { getInquiryShipperRoute, getInquiryFFRoute } from 'src/routing/utils';
import ShipIcon from 'src/components/common/icons/ShipForBookingIcon';
import MISReportView from '../../../common/MISReportView';
import { getStatus, BOOKING_STATUS, slRespondedFilters, SL_RESPONDED_INTTRA_STATUS, getBookingRoute } from './BookingUtils';
import withInquiryMasterData from '../hoc/InitInquiryMaster';
import InquiryModes from '../InquiryModes';
import { isValidArray } from 'src/Library/Helper';
import classNames from 'classnames';
import { tokens } from 'src/design-system';

const Option = Select.Option;

const styles = theme => ({
  selectSearchStyle: {
    width: '140px',
    '& .ant-select-selection': {
      borderRadius: '4px 0 0 4px',
    },
  },
  outerBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: '13px 24px',
    paddingBottom: '0px',
    '& .ant-btn-primary': {
      boxShadow: '0 0 0 0 rgba(0, 0, 0, 0) !important',
      textShadow: '0 0 0 0 rgba(0, 0, 0, 0) !important',
    },
    minWidth: '1080px',
  },
  toolbarWhite: {
    width: '100%',
    display: 'flex',
    background: tokens.colors.bgWhite,
    paddingTop: '12px',
    paddingBottom: '1px',
    marginBottom: 2,
    justifyContent: 'space-between',
    border: '1px solid #D9D9D9',
    borderTop: 'none',
    borderRadius: `${tokens.radius.md}px`,
    borderTopLeftRadius: '0px',
  },
  search: {
    '& .ant-select-selection--multiple .ant-select-selection__clear': {
      marginRight: '10px',
      borderRadius: '0 4px 4px 0',
      height: '100%',
      overflowY: 'scroll',
    },
    width: '158px',
    height: '30px',
    '& .ant-select-selection__placeholder': {
      fontSize: '13px !important',
    },
  },
  typeFilterSelected: {
    color: tokens.colors.primary,
    borderRadius: '0',
  },
  bottomButtons: {
    bottom: 30,
  },
  notFound: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  errorBlock: {
    margin: '15px',
  },
  cancelledByShipper: {
    backgroundColor: 'rgba(218,92,67,0.08)',
    fontWeight: tokens.fontWeight.semibold,
    color: '#262626',
    padding: '13px 16px',
    width: '100%',
    margin: '8px 0',
    borderRadius: `${tokens.radius.md}px`,
  },
  filterList: {
    borderRadius: '17px',
    padding: '8px 12px',
    marginRight: '8px',
    fontSize: `${tokens.fontSize.small}px`,
    cursor: 'pointer',
  },
  filterSelected: {
    backgroundColor: '#555555',
    border: '1px solid #555555',
    color: tokens.colors.bgWhite,
    fontWeight: tokens.fontWeight.semibold,
  },
  filterNotSelected: {
    border: '1px solid #CCCCCC',
    backgroundColor: tokens.colors.bgWhite,
    color: '#999999'
  },
  tabStyle: {
    '& .ant-tabs-tab-prev-icon, .ant-tabs-tab-next-icon': {
      '& .anticon anticon-right, .ant-tabs-tab-next-icon-target': {
        fontSize: `${tokens.fontSize.h3}px`,
        color: tokens.colors.primary,
      },
    },
    '& .ant-tabs-tab-prev-icon': {
      '& .anticon anticon-left, .ant-tabs-tab-prev-icon-target': {
        fontSize: `${tokens.fontSize.h3}px`,
        color: tokens.colors.primary,
      },
    },
  },
});

class BookingList extends React.PureComponent<any, any> {

  currentRequestId = 0;

  currentCancelToken: {
    cancel: (message: string) => void;
    token: any;
  } | null = null;

  state: any = {
    isSearching: true,
    activeKey: [],
    popupVisible: false,
    sortVisible: false,
    clearVisible: false,
    dropdown: [],
    isDrawerVisible: false,
    drawerData: {},
    isToggle: false,
  };

  // interval for handling auto Refresh
  interval: NodeJS.Timeout;

  debounceTimer: NodeJS.Timeout| null = null;

  popupFunc = (popup) => {
    if (popup === true) {
      return <BookingFilterPopup
        type={this.props.type}
        loading={this.props.isLoading}
        closeFilter={this.closeFilter}
        handleCancel={this.handleCancel}
        handleApply={this.handleApply} />;
    }
    return <div></div>;
  }

  setBookingId = (applyFilter = true) => {
    const {
      bookingSetFilter,
      bookingApplyFilter,
      match,
    } = this.props;

    const id = match.params.bookingId;
    const bookingNumber = match.params.bookingNumber;
  
    this.setState({
      dropdown: [{ id, bookingNumber, searchType: 'BOOKING_NUMBER' }],
      selectedBookingNumber: {
        key: id,
        label: bookingNumber,
      },
    });
    bookingSetFilter({ bookingIdList: id });
    if (applyFilter) bookingApplyFilter();
  }

  async componentDidMount() {
    const {
      bookingSetFilter,
      bookingResetFilter,
      match,
      location,
      history,
    } = this.props;

    const id = match.params.bookingId;

    const searchArray = location?.search?.replace('?modeList=', '');
    if (searchArray) {
      if (id) {
        this.setBookingId(false);
      }
      bookingSetFilter({ modeList: searchArray?.toUpperCase()?.split(',') }, true);
    } else if (!searchArray && isValidArray(this.props.appliedFilters?.modeList)) {
      if (id) {
        this.setBookingId();
      }
      bookingSetFilter({ modeList: [] }, true);
    } else if (id) {
      this.setBookingId();
    } else {
      bookingResetFilter(true);
      bookingSetFilter({ modeList: [] }, true);
    }
    this.interval = setInterval(() => this.props.setPrevPagination(), 60000);

    const successMessage = location?.state?.successMessage;
    if (successMessage) {
      message.success(successMessage);
      const state = { ...history.location.state };
      state.successMessage = '';
      history.replace({ ...history.location, state });
    }
  }

  componentWillUnmount() {
    if (this.currentCancelToken) {
      this.currentCancelToken.cancel('Component unmounted');
    }
    
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setStatusFilter = (status) => {
    if ('ALL' === status) {
      this.props.bookingSetFilter({
        statusList: [],
        inttraStatusList: [],
      });
    } else {
      this.props.bookingSetFilter({
        statusList: [status],
        inttraStatusList: [],
      });
    }

    this.props.bookingApplyFilter();
  }

  handleFilterClick = () => {
    this.setState({
      popupVisible: !this.state.popupVisible,
      sortVisible: false,
    });
  }

  handleReload = () => {
    this.props.setPrevPagination();
    this.closeFilter();
  }

  timeout: any = null;

  handleInquirySearch = (val) => {
    if (val.length) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.setState({
        isSearching: true,
      });
      this.timeout = setTimeout(() => {
        this.searchInquiry(val);
      }, 200);
    } else {
      this.timeout && clearTimeout(this.timeout);
      this.setState({ dropdown: [] });
    }
  }

  handleBookingSearch = (val: string) => {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  
    if (!val.trim()) {
      this.setState({ dropdown: [], isSearching: false });
      return;
    }
  
    this.setState({ isSearching: true });
  
    this.debounceTimer = setTimeout(() => {
      this.searchBooking(val);
    }, 300);
  }

  handleApply = () => {
    this.props.bookingApplyFilter();
    this.setState({
      popupVisible: false,
    });
  }

  handleSortClick = () => {
    this.setState({
      sortVisible: !this.state.sortVisible,
      popupVisible: false,
    });
  }

  closeFilter = () => {
    this.props.cancelFilter();
    this.setState({
      popupVisible: false,
      sortVisible: false,
    });
  }

  handleCancel = () => {
    this.props.cancelFilter();
    this.setState({
      popupVisible: false,
    });
  }

  handlePrevClick = (step) => {
    this.props.bookingSetPagination({
      currentPageNumber: this.props.pagination.currentPageNumber,
      lastInquiryId: this.props.pagination.lastItemIdPrev,
      lastSortedColumnValue: this.props.pagination.lastSortedColumnValuePrev,
      nextOrPrev: 'prev',
    });
  }

  handleNextClick = (step) => {
    this.props.bookingSetPagination({
      currentPageNumber: this.props.pagination.currentPageNumber,
      lastInquiryId: this.props.pagination.lastItemIdNext,
      lastSortedColumnValue: this.props.pagination.lastSortedColumnValueNext,
      nextOrPrev: 'next',
    });
  }

  handleFirstPageClick = () => {
    this.props.bookingResetFilter();
  }

  handleToggleView = (val) => {
    this.setState({
      isToggle: val,
    });
  }

  searchInquiry = async (search) => {
    if (!this.state.isSearching) {
      this.setState({
        isSearching: true,
      });
    }
    const response: any = await searchInquiryForShipperApi({ inquiryString: search });
    this.setState({
      isSearching: false,
      dropdown: response.response,
    });
  }

  searchBooking = async (search) => {
    this.currentRequestId += 1;
    const requestId = this.currentRequestId;
    
    if (this.currentCancelToken) {
      this.currentCancelToken.cancel('Operation canceled due to new request.');
    }
  
    this.currentCancelToken = axios.default.CancelToken.source();
  
    try {
      const response: any = await searchBookingApi(
        { queryString: search ? search.trim() : search, organisationType: this.props.type },
        this.currentCancelToken,
      );
      
      if (requestId === this.currentRequestId) {
        if (response.isSuccess) {
          this.setState({
            isSearching: false,
            dropdown: response.data,
          });
        } else {
          this.setState({
            isSearching: false,
          });
        }
      }
    } catch (error) {
      if (requestId === this.currentRequestId) {
        this.setState({
          isSearching: false,
        });
      }
      if (!axios.default.isCancel(error)) {
        console.error('Search error:', error);
      }
    }
  }

  getAppliedFiltersCount = () => {
    const { appliedFilters, type } = this.props;
    const polApplied = appliedFilters.polList && appliedFilters.polList.length > 0 ? 1 : 0;
    const podApplied = appliedFilters.podList && appliedFilters.podList.length > 0 ? 1 : 0;
    const originCountryApplied = appliedFilters.originCountryList && appliedFilters.originCountryList.length > 0 ? 1 : 0;
    const destinationCountryApplied = appliedFilters.destinationCountryList && appliedFilters.destinationCountryList.length > 0 ? 1 : 0;
    const originCityApplied = appliedFilters.originCityList && appliedFilters.originCityList.length > 0 ? 1 : 0;
    const destinationCityApplied = appliedFilters.destinationCityList && appliedFilters.destinationCityList.length > 0 ? 1 : 0;
    const orgApplied = type === 'SHIPPER' ? isValidArray(appliedFilters.ffList) ? 1 : 0 :
      isValidArray(appliedFilters.shipperList) ? 1 : 0;
    return polApplied + podApplied + orgApplied + originCityApplied + destinationCityApplied + originCountryApplied + destinationCountryApplied;

  }

  clearFilters = () => {
    this.props.bookingResetFilter();
    this.setState({
      popupVisible: false,
    });
  }

  handleSearchTypeChange = (value) => {
    const { bookingApplyFilter, bookingSetFilter, appliedFilters } = this.props;
    if (appliedFilters.searchType !== value) {
      let reload = false;
      if (appliedFilters.searchType === 'INQUIRY') {
        if (appliedFilters.bookingIdList) {
          reload = true;
        }
      } else {
        if (appliedFilters.inquiryIdList) {
          reload = true;
        }
      }
      bookingSetFilter({ searchType: value, bookingIdList: undefined, inquiryIdList: undefined });
      // if (appliedFilters.bookingIdList !== appliedFilters.inquiryIdList) {
      //   bookingApplyFilter();
      // }
      bookingApplyFilter(!reload);
      this.setState({
        dropdown: [],
      });
    }
  }

  handleInquiryChange = (search, option) => {
    const { bookingApplyFilter, bookingSetFilter } = this.props;
    bookingSetFilter({
      inquiryIdList: search,
    });
    bookingApplyFilter();
  }

  handleBookingChange = (search, option) => {
    const { bookingApplyFilter, bookingSetFilter, bookingResetFilter } = this.props;
    const { dropdown } = this.state;
    let searchType: any = '';
    if (search !== undefined) {
      dropdown.map((item) => {
        if (item.id === search.key && item.bookingNumber === search.label) {
          searchType = item.searchType;
        }
      });
      if (searchType !== 'INTERNAL_REFERENCE_NUMBER') {
        bookingSetFilter({
          bookingIdList: search.key,
        });
        bookingApplyFilter();
      } else {
        bookingSetFilter({
          internalReferenceNumberList: [search.label],
        });
        bookingApplyFilter();
      }
    } else {
      bookingResetFilter();
      bookingApplyFilter();
    }
    this.setState({ selectedBookingNumber: {
      key: option && option.key || undefined,
      label: option && option.props
      && option.props['data-value'] || undefined,
    }});
  }

  setDrawerData = (data) => {
    this.setState({
      drawerData: data,
      isDrawerVisible: true,
    });
  }

  closeSideDrawer = () => {
    this.setState({
      isDrawerVisible: false,
    });
  }

  renderNoData = () => {
    const { classes, theme, type } = this.props;
    const clickHere = type === 'SHIPPER' ? getInquiryShipperRoute : getInquiryFFRoute;
    const content = type === 'SHIPPER' ?
    <>
      <div style={{ color: '#666666', fontWeight: tokens.fontWeight.semibold, paddingTop: 10, fontSize: 21 }}>
      Oops, Seems like you haven’t booked anything.</div>
      <div style={{ color: '#666666', fontWeight: tokens.fontWeight.semibold, paddingTop: 10, fontSize: 21 }}>
        To get started, <span
          onClick={() => this.props.history.push(clickHere(),
            { statusFilter: 'CONFIRMED' })}
          style={{
            color : theme.primaryColor,
            cursor: 'pointer',
          }}>
        Click Here!</span> to Book the confirmed bids.
      </div>
    </>
    : <>
    <div style={{ color: '#666666', fontWeight: tokens.fontWeight.semibold, paddingTop: 10, fontSize: 21 }}>
      Uh-Oh, You have no bookings,</div>
      <div style={{ color: '#666666', fontWeight: tokens.fontWeight.semibold, paddingTop: 10, fontSize: 21 }}>
        please send or revise bids to receive bookings or try adjusting your filters.
      </div>
    </>;
    return (<div className={classes.notFound}>
        <div style={{ display: 'flex', alignItems: 'center',
          flexDirection: 'column', marginTop: '8%' }}>
        <div className={classes.notFoundItems}>
          <ShipIcon className={classes.blackIcon}
          width="184" height="184"></ShipIcon></div>
        {content}
      </div>
    </div>);
  }

  isFilterApplied = () => {
    const { appliedFilters, type } = this.props;
    return isValidArray(appliedFilters.polList) ||
      isValidArray(appliedFilters.podList) ||
      isValidArray(appliedFilters.typeList) ||
      (type === 'SHIPPER' ? isValidArray(appliedFilters.ffList) :
      isValidArray(appliedFilters.shipperList));
  }

  handleActiveInttraRequestFilter = (showActiveInttraBookings) => {
    this.props.bookingSetFilter({
      showActiveInttraBookings,
    });
  }

  renderActiveInttraBookingFilter = () => {
    const { appliedFilters, type, showInttraBookingFF } = this.props;
    return (
      showInttraBookingFF && isValidArray(appliedFilters?.statusList) &&
        appliedFilters?.statusList[0] === BOOKING_STATUS.CANCELLED && type === 'FF' &&
        <div style={{
          margin: '-2px 0 0 18px', display: 'flex',
        }}>
          <Checkbox
            checked={appliedFilters?.showActiveInttraBookings}
            onChange={(e) => {
              this.handleActiveInttraRequestFilter(e.target.checked);
              this.props.bookingApplyFilter();
            }}
          >
            Active INTTRA Bookings
          </Checkbox>
      </div>
    );
  }

  handleInttraStatusFilterClick = (filterValue) => {
    const { appliedFilters } = this.props;
    if (filterValue === SL_RESPONDED_INTTRA_STATUS.ALL) {
      this.props.bookingSetFilter({
        inttraStatusList: undefined,
      });
    } else if (!isValidArray(appliedFilters?.inttraStatusList)) {
      this.props.bookingSetFilter({
        inttraStatusList: [filterValue],
      });
    } else if (appliedFilters?.inttraStatusList?.indexOf(filterValue) === -1) {
      this.props.bookingSetFilter({
        inttraStatusList: [
          ...appliedFilters.inttraStatusList,
          filterValue,
        ],
      });
    } else {
      const inttraStatusList = appliedFilters.inttraStatusList?.filter(filter => filter !== filterValue);
      this.props.bookingSetFilter({
        inttraStatusList,
      });
    }
    this.props.bookingApplyFilter();
  }

  renderSLRespondedFilter = () => {
    const {
      appliedFilters,
      type,
      showInttraBookingFF,
      classes,
      statusWiseBookingCount,
      isLoading,
    } = this.props;
    const selectedSLStatus = appliedFilters?.inttraStatusList;
    return (
      showInttraBookingFF && isValidArray(appliedFilters?.statusList) &&
        appliedFilters?.statusList[0] === BOOKING_STATUS.SL_RESPONDED && type === 'FF' &&
        <div style={{
          margin: '-8px 0px 8px 18px',
          display: 'flex',
        }}>
          {slRespondedFilters.map(filter => (
            <span
              onClick={() => this.handleInttraStatusFilterClick(filter.key)}
              className={
                (isValidArray(selectedSLStatus) ? selectedSLStatus.indexOf(filter.key) !== -1 :
                (filter.key === SL_RESPONDED_INTTRA_STATUS.ALL)) ?
                classNames(classes.filterList, classes.filterSelected) :
                classNames(classes.filterList, classes.filterNotSelected)
              }
              key={filter.key}
            >
                {filter.label} {
                  (!isLoading && statusWiseBookingCount) ?
                    statusWiseBookingCount[filter.status]
                  :
                  <span className={'loadingDotsBlue'}></span>
                }
            </span>
          ))}
      </div>
    );
  }

  FilterToolbar = (props: any) => {
    const { classes, isLoading, pagination, appliedFilters, type, modules } = props;
    
    const { isSearching, popupVisible, sortVisible, dropdown, selectedBookingNumber } = this.state;
    const totalCnt = this.getAppliedFiltersCount();
    const hideInquiryModes = appliedFilters?.statusList && [
      BOOKING_STATUS.SL_RESPONDED,
      BOOKING_STATUS.SL_RESPONSE_AWAITED].indexOf(appliedFilters.statusList[0]) !== -1;
    const bookingRoute = getBookingRoute(type);
    const getTagColor = (searchType) => {
      if (searchType === 'INTERNAL_REFERENCE_NUMBER') return 'purple';
      if (searchType === 'BOOKING_NUMBER') return 'volcano';
      return 'cyan';
    };
    return (
      <div>
        <div className={classes.toolbarWhite}>
          <div style={{
            display: 'flex', marginTop: '8px',
            flexDirection: 'row', paddingLeft: 16,
          }}>
            <div style={{ display: 'flex', marginTop: '-6px' }}>
              <Tooltip title="Search Booking, Inquiry, or Internal Number"
                        overlayStyle={{ maxWidth: '350px' }}>
              <Select
                showSearch
                allowClear
                defaultActiveFirstOption={false}
                filterOption={false}
                notFoundContent={this.state.isSearching ? <Spin size="small" /> : 'Not Found'}
                suffixIcon={<Icon type="search" />}
                className={classes.search}
                placeholder={'Search'}
                onFocus={() => this.searchBooking('')}
                onChange={this.handleBookingChange}
                onSearch={this.handleBookingSearch}
                labelInValue
                dropdownMatchSelectWidth={false}
                optionLabelProp={'data-value'}
                value={
                  (selectedBookingNumber?.key || selectedBookingNumber?.id)
                  ? selectedBookingNumber : undefined
                }
              >
                {this.state.dropdown?.map((item: any) => (
                  <Option key={item.id} data-value={item.bookingNumber}>
                    <div style={{ display: 'flex' }}>
                      <div style={{ width: '70%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.bookingNumber}</div>
                      <div style={{ width: '30%' }}>
                        <Tag color={getTagColor(item.searchType)}>
                          {searchTypeMap[item.searchType]}
                        </Tag>
                      </div>
                    </div>
                  </Option>
                ))}
              </Select>
              </Tooltip>
            </div>
            {this.renderSLRespondedFilter()}
            {!hideInquiryModes &&
              <InquiryModes appliedFilters={this.props.appliedFilters} 
              modules={modules}
                setFilter={modeList => {
                  this.props.bookingSetFilter({ modeList });
                  this.props.history.push(bookingRoute(isValidArray(modeList) ? `modeList=${modeList}` : ''));
                }}
              />}
            <div style={{
              marginLeft: '15px',
              height: '37px', cursor: 'pointer',
              display: 'flex',
              position: 'relative',
              marginTop: '-1px',
            }} onClick={this.handleFilterClick}
                data-testid={'view-filters'}>
              <Icon type="filter" style={{
                height: '14px', width: '14px',
                marginTop: '3px',
                color: (totalCnt === 0 ? '#424242' : tokens.colors.primary),
              }} theme={this.isFilterApplied() ?
                'filled' : 'outlined'} />
              <span style={{
                fontFamily: 'Open Sans',
                paddingLeft: '10px',
              }} >Filters</span>
              {totalCnt > 0 ? <span style={{ marginLeft: '8px', fontWeight: 600 }}>
                ({totalCnt})</span> : <span></span>}
            </div>
            <div style={{
              marginLeft: '18px', display: 'flex',
              height: '37px', cursor: 'pointer',
              marginTop: '-2px',
            }} onClick={this.handleSortClick}>
              <SortIcon style={{
                height: '14px', width: '14px', marginTop: '5px',
              }} />
              <span style={{
                fontFamily: 'Open Sans',
                paddingLeft: '10px',
              }}>Sort By</span>
            </div>
            {this.renderActiveInttraBookingFilter()}
            {totalCnt && !isLoading ? <div style={{
              height: '37px', display: 'flex',
              marginLeft: '18px', cursor: 'pointer',
            }} onClick={this.clearFilters}>
              <span style={{ color: tokens.colors.primary, cursor: 'pointer', fontWeight: 600 }}>
                Clear Filters</span>
            </div> : <div />}
          </div>
          <div style={{
            marginTop: '2px', display: 'flex',
            flexDirection: 'row', marginRight: '2%',
          }}>
            <div style={{ display: 'flex' }}>
              <Tooltip title="Reload">
                <Button icon="reload" disabled={isLoading}
                  onClick={this.handleReload}
                ></Button>
              </Tooltip>
            </div>

            <div style={{ display: 'flex', marginLeft: '7%' }} >
              <SimplePaginator
                loading={isLoading}
                isNext={pagination.isNextPresent ? pagination.isNextPresent : false}
                onFirstClick={this.handleFirstPageClick}
                onPrevClick={() => this.handlePrevClick('prev')}
                onNextClick={() => this.handleNextClick('next')}
                pageNumber={pagination.currentPageNumber}
              />
              <div style={{ margin: '0px 16px' }}>
                <Select value={`${pagination.resultPerPage} / page`}
                  disabled={isLoading}
                  onChange={(resultPerPage) => {
                    if (resultPerPage !== pagination.resultPerPage) {
                      this.props.bookingSetPagination({ resultPerPage });
                    }
                  }}>
                  <Select.Option key={'10'}> 10 / page</Select.Option>
                  <Select.Option key={'25'}> 25 / page</Select.Option>
                  <Select.Option key={'50'}> 50 / page</Select.Option>
                  <Select.Option key={'100'}>100 / page</Select.Option>
                </Select>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  StatusTabs = (props: any) => {
    const { classes, isLoading, appliedFilters, statusWiseBookingCount, type, showInttraBookingFF, permissions: { INQUIRY_VIEW_BIDS_ACTIONS } } = props;
    const status = getStatus(type, showInttraBookingFF);
    const activeTabKey = isValidArray(appliedFilters?.statusList) ?
    status.findIndex((item) => {
      const val = isValidArray(appliedFilters?.statusList) ?
        appliedFilters.statusList[0] : undefined;
      return item.status === val;
    }) : 0;

    return (
        <Tabs type="card"
          activeKey={activeTabKey.toString()}
          tabBarGutter={-1}
          className={classes.tabStyle}
          tabBarStyle={{ marginBottom: '0px' }}
          tabBarExtraContent={
            <div style={{ display: 'flex' }}>
              {this.props.type === 'SHIPPER' && INQUIRY_VIEW_BIDS_ACTIONS ? <Button
              style={{
                background: 'transparent',
                border: '1px solid #1890FF',
                color: tokens.colors.primary,
                borderRadius: `${tokens.radius.md}px`,
                marginRight: '10px',
              }}
              onClick={() => {
                this.handleToggleView(true);
              }}
            >
              Reports
              </Button> : ''}
            </div>}
          onChange={(key) => {
            const element = status[parseInt(key, 10)];
            (appliedFilters?.showActiveInttraBookings || appliedFilters?.inttraStatusList) &&
            this.props.bookingSetFilter({
              inttraStatusList: undefined,
              showActiveInttraBookings: undefined,
            });
            this.setStatusFilter(element.status);
          }}>
          {status.map((element, ind) => {
            return (
              <Tabs.TabPane
                disabled={isLoading}
                tab={
                  <span style={{ display: 'flex' }}>
                    {element.label}
                    <div
                      style={{
                        color: 'white', marginLeft: '7px',
                      }}>
                      {!isLoading && statusWiseBookingCount
                        ? <Tooltip title={statusWiseBookingCount[element.data_key]}>
                          <Badge count={statusWiseBookingCount[element.data_key]}
                            title=" "
                            style={{ backgroundColor: element.color }}
                            showZero /></Tooltip> :
                        <span className={'loadingDotsBlue'}></span>}
                    </div>
                  </span>
                }
                key={ind.toString()}
              >
                <this.FilterToolbar {...this.props} />
              </Tabs.TabPane>
            );
          })}
        </Tabs>
    );
  }

  getInttraErrorAndCancelledText = () => {
    const { statusWiseBookingCount } = this.props;
    const cancelledCount = statusWiseBookingCount?.cancelledByShipperActiveInttraBookings;
    const errorCount = statusWiseBookingCount?.SLErrored;
    if (cancelledCount && errorCount) {
      return (
        <span>
          <a onClick={() => {
            this.handleActiveInttraRequestFilter(true);
            this.setStatusFilter(BOOKING_STATUS.CANCELLED);
          }}>{cancelledCount} INTTRA active booking(s) </a>
          have been cancelled by shipper(s) and
          <a onClick={() => this.setStatusFilter(BOOKING_STATUS.SL_ERRORED)}> {errorCount} booking request(s) </a>
          placed on INTTRA have failed. Click on bookings to take appropriate action.
        </span>
      );
    }
    if (errorCount) {
      return (
        <span>
          <a onClick={() => this.setStatusFilter(BOOKING_STATUS.SL_ERRORED)}>{errorCount} booking request(s) </a>
          placed on INTTRA have failed. Click on bookings to take appropriate action.
        </span>
      );
    }
    if (cancelledCount) {
      return (
        <span>
          <a onClick={() => {
            this.handleActiveInttraRequestFilter(true);
            this.setStatusFilter(BOOKING_STATUS.CANCELLED);
          }}>{cancelledCount} INTTRA active booking(s) </a>
          have been cancelled by shippers. Click on bookings to take appropriate action.
        </span>
      );
    }
    return;
  }

  renderBookingsCancelledByShipperPopUp = () => {
    const { classes, statusWiseBookingCount } = this.props;
    return (
      <div className={classes.cancelledByShipper}>
        <Icon type="exclamation-circle" style={{ color: 'rgba(218,92,67,0.85)', marginRight: '8px' }} />
        {this.getInttraErrorAndCancelledText()}
      </div>
    );
  };

  render() {
    const {
      classes,
      isLoading,
      bookingData,
      type,
      statusWiseBookingCount,
      appliedFilters,
      showInttraBookingFF,
    } = this.props;
    const { isDrawerVisible, drawerData, popupVisible, sortVisible, activeTabKey } = this.state;
    const showCancelledPopup = type === 'FF' && showInttraBookingFF &&
      (statusWiseBookingCount?.cancelledByShipperActiveInttraBookings || statusWiseBookingCount?.SLErrored)
      && ((appliedFilters?.statusList &&
      [
        BOOKING_STATUS.SL_RESPONSE_AWAITED,
        BOOKING_STATUS.SL_RESPONDED,
        BOOKING_STATUS.CONFIRMED,
      ].indexOf(appliedFilters.statusList[0]) !== -1) ||
        !isValidArray(appliedFilters?.statusList));
    return (
      <div className={classes.outerBox}>
        {this.state.isToggle ?
        <div>
        <MISReportView
        getDashboardUrl={async () => {
          const response = await getBookingMISReport();
          return response.response?.dashboardUrl;
        }}
        onBack={this.handleToggleView}
        />
        </div> :<div>
        <this.StatusTabs {...this.props}/>

        <div style={{ position: 'relative' }}>
          {this.popupFunc(popupVisible)}
          {sortVisible ? <BookingSortPopup closeFilter={this.closeFilter}
            loading={this.props.isLoading} type={this.props.type} /> :
            <div />}
        </div>

        {
          isLoading &&
          <div style={{ height: '100%' }}>
            <Loader style={{position: 'fixed'}} zIndex={1} backgroundColor='rgb(255, 255, 255, 0.5)'/>
          </div>
        }

        {showCancelledPopup ? this.renderBookingsCancelledByShipperPopUp() : ''}
        {isValidArray(bookingData) ?
          bookingData.map(el => type === 'SHIPPER' ?
            <InquiryBookingShipperCard
              isLoading={isLoading}
              cardData={el} key={el.id}
              drawerData={this.setDrawerData}
            /> :
            <InquiryBookingFFCard
              isLoading={isLoading}
              cardData={el} key={el.id}
              drawerData={this.setDrawerData}
              handleReload={this.handleReload}
            />
          )
        : this.renderNoData()}

        {
          isDrawerVisible ?
            <BookingSideDrawer
              drawerData={drawerData}
              isVisible={isDrawerVisible}
              onClose={this.closeSideDrawer}
              type={this.props.type}
            >
            </BookingSideDrawer> :
            null
        }
        </div>}

      </div>
    );
  }
}

const mapStateToProps = ({ bookingInquiryReducer, masterData }) => {
  return {
    bookingData: bookingInquiryReducer.bookingData,
    isLoading: bookingInquiryReducer.isLoading,
    pagination: bookingInquiryReducer.pagination,
    appliedFilters: bookingInquiryReducer.appliedFilters,
    selectedFilters: bookingInquiryReducer.selectedFilters,
    statusWiseBookingCount: bookingInquiryReducer.statusWiseBookingCount,
    showInttraBookingFF: masterData.modules.show_inttra_booking_ff,
    permissions: masterData.permissions,
    modules: masterData.modules,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators({
    bookingResetFilter: bookingResetFilter(ownProps.type),
    bookingSetPagination: bookingSetPagination(ownProps.type),
    fetchAllBookingsShipper: fetchAllBookings(ownProps.type),
    bookingSetFilter: bookingSetFilter(ownProps.type),
    bookingApplyFilter: bookingApplyFilter(ownProps.type),
    cancelFilter: cancelFilter(ownProps.type),
    setPrevPagination: setPrevPagination(ownProps.type),
  }, dispatch);
};

const StyledBooking = injectSheet(styles)(BookingList);
export default withInquiryMasterData(withRouter(connect(mapStateToProps,
  mapDispatchToProps)(StyledBooking)));
